export enum PagadorArmazenagemTypes {
  'LOAD_REQUEST' = '@pagadorArmazenagem/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@pagadorArmazenagem/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@pagadorArmazenagem/LOAD_FAILURE',

  'CLEAN_PAG_ARMAZENAGEM' = '@pagadorArmazenagem/CLEAN__PAG_ARMAZENAGEM',
}

export interface IPagadorArmazenagem {
  codParc: number;
  nome: string;
  inscricaoEstadual: string;
  cnpjCpf: string;
}

export interface PagadorArmazenagemState {
  readonly data: IPagadorArmazenagem[];
  readonly loading: boolean;
  readonly error: boolean;
}
